import { Input } from 'antd';
import React, { useMemo } from 'react';
import Icon, { CloseIcon } from '../Icon';
import './styles.scss';
import cn from 'classnames';

const MyInputInstant = ({
  targetRef,
  className,
  allowClear,
  suffix,
  numericRegex,
  parseNumericRegex,
  isFormatNumber,
  defaultValue,
  ...rest
}) => {
  const handleChange = (e = '') => {
    return rest.onChange?.(typeof e === 'string' ? e : e.target.value);
  };

  const suffixIcon = useMemo(() => {
    if (allowClear && rest.value?.length) {
      return <Icon component={CloseIcon} onClick={handleChange} />;
    }
    return suffix;
  }, [suffix, allowClear, rest.value, rest.onChange]);

  const classNames = useMemo(() => {
    return cn('input-custom my-input-white', className);
  }, [className]);

  const renderInput = useMemo(() => {
    switch (rest.type) {
      case 'textarea':
        return (
          <Input.TextArea
            className={classNames}
            {...rest}
            onChange={handleChange}
            suffix={suffixIcon}
          />
        );
      default:
        return (
          <Input
            className={classNames}
            {...rest}
            onChange={handleChange}
            suffix={suffixIcon}
            ref={targetRef}
            defaultValue={defaultValue}
          />
        );
    }
  }, [rest]);

  return <div id="my-input-instant">{renderInput}</div>;
};

MyInputInstant.propTypes = {
};

MyInputInstant.defaultProps = {
  numericRegex: /^-?\d*(\.\d*)?$/,
  parseNumericRegex: /,/gi,
  isFormatNumber: false,
};

export default MyInputInstant;